import { Link } from 'react-router-dom'
import { Container, Grid, Item } from '../common'

import items from '../data/objects.json'

const Images = () => {
  return (
    <Container>
      <Grid>
        {Object.keys(items).map((id) => (
          <Link to={id && `/objects/${id}`} key={id}>
            <Item item={items[id]} placeholder="/obj.svg" />
          </Link>
        ))}
      </Grid>
    </Container>
  )
}

export default Images
